import Lambda from 'aws-sdk/clients/lambda'

export default async function lambdaInvokeRegistrationData(token) {
    let lambda = new Lambda({
        region: 'us-west-2',
        apiVersion: '2015-03-31',
        credentials: {
            accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
            secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
        },
    })

    let payload = `{"token": "${token}"}`

    let params = {
        FunctionName: `arn:aws:lambda:us-west-2:${process.env.REACT_APP_AWS_ACCOUNT_ID}:function:BSS-QueryRegistrationData-${process.env.REACT_APP_STAGE}-${process.env.REACT_APP_AWS_ACCOUNT_ID}`,
        InvocationType: 'RequestResponse',
        Payload: payload,
    }

    try {
        let response = await lambda.invoke(params).promise()
        return JSON.parse(response.Payload)
    } catch (err) {
        console.log('Invoke Error: ', err)
    }
}
